import { render, staticRenderFns } from "./refundV3.vue?vue&type=template&id=70e10b18&"
import script from "./refundV3.vue?vue&type=script&lang=js&"
export * from "./refundV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports